<template>
	<li class="sidebarItem">
		<div class="linkWrapper">
			<span 
				v-if="hasChildren" 
				class="hasChildren"
				:class="open ? 'showChildren' : ''"
				@click="toggleOpen"
			></span>
			<router-link
				:to="(isSpecials) ? {name: 'specials'} : {name:'category', params:{category: category.id}}"
				class="categoryLink"
				:class="activeCategory ? 'activeCategory' : ''"
			>
				<strong v-if="isShowroomStock">
					{{category.name}}
				</strong>
				<span v-else>
					{{category.name}}
				</span>
			</router-link>
		</div>
		<ul
			class="subcategoryList" 
			v-if="hasChildren"
			:style="'max-height: ' + maxHeight + 'px;'"
			ref="subCatList"
		>
			<li v-for="child in category.children" :key="child.id" class="sidebarItem">
				<router-link
					:to="{name: 'subcategory', params:{category: category.id, subcategory: child.id}}"
					class="subcategoryLink"
				>
					{{child.category}}
				</router-link>
			</li>
		</ul>
	</li>
</template>

<script>

export default {
	name: 'CategorySidebarListItem',
	data() {
		return {
			open: false,
			height: 0,
		}
	},
	components: {},
	props: ["category"],
	created() {
		if("id" in this.category) {
			this.open = this.$route.params.category == this.category.id
		}
		
	},
	mounted() {
		if(this.hasChildren && "subCatList" in this.$refs) {
			for (let child of this.$refs.subCatList.children){
				this.height += child.offsetHeight;
			}
		}
		this.$emit('openItem', {id: this.category.id, height: this.height})
	},
	computed: {
		maxHeight() {			
			if (this.open) {
				return this.height;
			}
			return 0;
		},
		isSpecials() {
			return this.category.name.toLowerCase() == "specials";
		},
		isShowroomStock() {
			return this.category.name.toLowerCase() == "showroom stock";
		},
		hasChildren () {
			if("children" in this.category) {
				return Object.keys(this.category.children).length !== 0;
			}
			return false;
		},
		activeCategory() {
			return ("id" in this.category && this.$route.params.category == this.category.id) || (this.isSpecials && this.$route.name.toLowerCase() == "specials");
		}
	},
	methods: {
		toggleOpen() {
			this.open=!this.open;
		}
	}
}
</script>

<style lang="scss" scoped>

</style>
